import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import styles from './AddNoteModal.module.css';
import api from '../api';

const EditNoteModal = ({ isOpen, note, onClose, onSuccess, onNoteUpdated }) => {
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [noteType, setNoteType] = useState('Property Note');
  const [pinToTop, setPinToTop] = useState(false);

  // Initialize form with note data when modal opens or note changes
  useEffect(() => {
    if (note && isOpen) {
      setDescription(note.content || '');
      setNoteType(note.type || 'Property Note');
      setPinToTop(note.is_flagged || false);
    }
  }, [note, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description.trim()) {
      toast.error('Please enter a note description');
      return;
    }

    if (!note || !note.id) {
      toast.error('Note ID is required for editing');
      return;
    }

    setLoading(true);
    try {
      // Determine the endpoint based on note type or context
      const endpoint = note.ticket_id
        ? `/tickets/${note.ticket_id}/notes/${note.id}`
        : `/notes/${note.id}`;

      const response = await api.put(endpoint, {
        content: description.trim(),
        type: noteType,
        is_flagged: pinToTop
      });

      const data = response.data;
      toast.success('Note updated successfully!');

      // Call the appropriate success callback
      if (onSuccess) {
        onSuccess();
      }
      if (onNoteUpdated) {
        onNoteUpdated(data);
      }

      // Close the modal after successful update
      onClose();
    } catch (error) {
      console.error('Error updating note:', error);
      toast.error(error.message || 'Failed to update note');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h3>Edit note</h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.modalBody}>
            <div className={styles.formGroup}>
              <label htmlFor="noteType">Property Note</label>
              <select
                id="noteType"
                className={styles.select}
                value={noteType}
                onChange={(e) => setNoteType(e.target.value)}
              >
                <option value="Property Note">Property Note</option>
                <option value="Maintenance Note">Maintenance Note</option>
                <option value="Inspection Note">Inspection Note</option>
                <option value="General Note">General Note</option>
              </select>
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={pinToTop}
                  onChange={(e) => setPinToTop(e.target.checked)}
                  className={styles.checkbox}
                />
                Pin to top
              </label>
            </div>

            <div className={styles.formGroup}>
              <textarea
                className={styles.textarea}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={6}
                placeholder="Enter your note here..."
                required
              />
            </div>
          </div>
          <div className={styles.modalFooter}>
            <button
              type="submit"
              className={styles.addButton}
              disabled={loading || !description.trim()}
            >
              <span className={styles.plusIcon}>+</span>
              {loading ? 'Updating...' : 'Update Note'}
            </button>
            <button
              type="button"
              className={styles.closeButton}
              onClick={onClose}
              disabled={loading}
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditNoteModal;